import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getToken, clearUser } from './auth'
import { message } from 'antd'
import { localizeApiErrorResponse, localizeErrorMessage, localizeRequestError } from './errorMessage'

export interface SmartPNTRequestConfig<D = any> extends AxiosRequestConfig<D> {
  returnRawResponse?: boolean
}

export const http = axios.create({
  timeout: 30 * 1000,
})

http.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      'x-token': getToken(),
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

http.interceptors.response.use(
  (response) => {
    if (response.data?.errorCode === 10006) {
      message.error(localizeErrorMessage(response?.data.errorMsg, '登录状态已失效，请重新登录。'))
      clearUser()
      window.location.href = '/auth/login'
    }
    return response
  },
  (error) => {
    // A forbidden operation must preserve the current session. Only an
    // authentication failure invalidates the saved credentials.
    if (error.response?.status === 401 || error.response?.data?.errorCode === 10006) {
      clearUser()
      window.location.href = '/auth/login'
    }
    if (error.response?.status === 403 && !/\/auth\/(profile|authorization-version)(?:\?|$)/.test(error.config?.url || '')) {
      window.dispatchEvent(new Event('authorization-denied'))
    }
    return Promise.reject(localizeRequestError(error))
  },
)

export function httpRequest <T = any, R = AxiosResponse<T>, D = any> (config: SmartPNTRequestConfig<D>): Promise<R> {
  const { returnRawResponse, ...axiosConfig } = config
  return http<T, AxiosResponse<T>, D>(axiosConfig).then((resp: any) => {
    if (returnRawResponse) {
      return resp
    }
    if (resp.status >= 200 && resp.status < 300) {
      return localizeApiErrorResponse(resp.data)
    }

    return resp
  }).catch(error => Promise.reject(localizeRequestError(error)))
}
